import React, { Component } from 'react';
import './App.css';

import Home from './Components/Home';
import Sidebar from './Components/Sidebar';
import CV from './Components/CV';
import Portfolio from './Components/Portfolio';
import About from './Components/About';

import Presentervote from './Components/Presentervote';
import CvApp from './Components/CvApp';
import Hospital from './Components/Hospital';
import Mp4to3 from './Components/Mp4to3';
import PlatformGame from './Components/PlatformGame';
import Restuarant from './Components/Restuarant';
import SalesMgmt from './Components/SalesMgmt';
import Onlineshop from './Components/Onlineshop';
import TicketLog from './Components/TicketLog';

class App extends Component {
  constructor(props){
    super(props);
    this.state= {
      view: 'home',
      mode: '',
      btntxt: "off",
      active: '',
      color: ' white',
      menu: '',
      menubtntxt: <i class="fa fa-bars" aria-hidden="true"></i>,
    }
  }

godark = () => {
  if(this.state.mode === " dark"){
    this.setState({mode: "", btntxt: "off", color: " white"})
  }
  else{
    this.setState({mode: " dark", btntxt: "on", color: " black"})
  }
}

alterpage = (link) => {
  this.setState({view: link})
  this.showMenu()
}

alterview = (link) => {
  this.setState({view: link})
}

showMenu = () => {
  var html = document.getElementById('html')
  var body = document.getElementById('body')
  if(this.state.menu === ' show'){
  this.setState({menu: '', menubtntxt: <i class="fa fa-bars" aria-hidden="true"></i>})
  } else {this.setState({menu: ' show', menubtntxt: <i class="fa fa-times" aria-hidden="true"></i>})
}
}

render(){
  const {
    view,
    mode,
    btntxt, 
    color,
    menu,
    menubtntxt,
  } = this.state;

  var activePage

  if(view === 'home'){
    activePage = <Home />
  }else if(view === 'cv'){
    activePage = <CV color={color}/>
  }else if(view === 'portfolio'){
    activePage = <Portfolio  color={color} alterview={this.alterview}/>
  }else if(view === 'about'){
    activePage = <About />
  }else if(view === 'cvapp'){
    activePage = <CvApp color={color}/>
  }else if(view === 'voter'){
    activePage = <Presentervote  color={color}/>
  }else if(view === 'shopper'){
    activePage = <Onlineshop />
  }else if(view === 'sales'){
    activePage = <SalesMgmt color={color}/>
  }else if(view === 'logger'){
    activePage = <TicketLog  color={color}/>
  }else if(view === 'converter'){
    activePage = <Mp4to3 />
  }else if(view === 'platformer'){
    activePage = <PlatformGame />
  }else if(view === 'menu'){
    activePage = <Restuarant />
  }else if(view === 'medapp'){
    activePage = <Hospital />
  }

  return (
    <div className={"App" + mode}>
      <button className={"menu-btn" + mode} onClick={this.showMenu}>{menubtntxt}</button>
    <div className="main-container">
    <div className={"sidebar" + menu}>
    <Sidebar godark={this.godark} alterpage={this.alterpage} btntxt={btntxt}/>
    </div>
    <div className="content">
    {activePage}
    </div>
    </div>
    </div>
  );
}
}

export default App;
